import React from 'react';

import Permissions from '@/common/permissions';
import { Access } from '@/modules/core/components';
import RoleSetup from '@/modules/role/RoleSetup';
const RoleSetupPage = () => {

  return (
    <Access
      accessRequirements={[
        { permission: Permissions.VIEW_ROLES_AND_SECURITY },
      ]}>
      <RoleSetup />
    </Access>
    
  );
};
export default RoleSetupPage;
